AFRAME.registerComponent('customrendersort', {
  schema: {
    customRenderOrder: {
      type: 'boolean',
    },
  },

  update: function () {
    const customRenderOrder = this.data.customRenderOrder;

    if (customRenderOrder) {
      this.el.renderer.sortObjects = customRenderOrder
    }
  }
});
